import { render, staticRenderFns } from "./quotes-block-knowledge.vue?vue&type=template&id=45dfe76f&scoped=true"
var script = {}
import style0 from "./quotes-block-knowledge.vue?vue&type=style&index=0&id=45dfe76f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45dfe76f",
  null
  
)

export default component.exports